import script from "./StreamManagerProductsLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./StreamManagerProductsLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__